import { render, staticRenderFns } from "./VueMyTable.vue?vue&type=template&id=0970c1e8&scoped=true&"
import script from "./VueMyTable.vue?vue&type=script&lang=js&"
export * from "./VueMyTable.vue?vue&type=script&lang=js&"
import style0 from "./VueMyTable.vue?vue&type=style&index=0&id=0970c1e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0970c1e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/releases/338/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0970c1e8')) {
      api.createRecord('0970c1e8', component.options)
    } else {
      api.reload('0970c1e8', component.options)
    }
    module.hot.accept("./VueMyTable.vue?vue&type=template&id=0970c1e8&scoped=true&", function () {
      api.rerender('0970c1e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/table/VueMyTable.vue"
export default component.exports